import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";
import type { SideMenuItemFields } from "../hooks/sideMenuItems.ts";

export interface ReportInfoExt extends ReportInfo, SideMenuItemFields {}

export enum ReportTypesEnum {
  All = "All",
  MyReports = "MyReports",
  SharedWithMe = "SharedWithMe",
}
